import { MessageCircle } from "lucide-react";

const WA_NUMBER = "593999307185";
const WA_MSG = encodeURIComponent("Hola, me interesa conocer más sobre las soluciones de impermeabilización de Construtop.");

export default function WhatsAppButton() {
  return (
    <a
      href={`https://wa.me/${WA_NUMBER}?text=${WA_MSG}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-btn"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg whatsapp-pulse hover:scale-110 transition-transform"
      title="Contactar por WhatsApp"
    >
      <MessageCircle size={28} fill="white" />
    </a>
  );
}
